import {CreateVehicleRequestBody} from '../../../types/CreateVehicleRequestBody';

export const TYPE_DEPENDENT_FIELDS: Array<
  keyof Pick<
    CreateVehicleRequestBody,
    | 'make'
    | 'modelFamily'
    | 'bodyStyle'
    | 'fuelType'
    | 'drive'
    | 'transmission'
    | 'hybridType'
    | 'secondaryFuelType'
    | 'battery'
    | 'electricVehicleBattery'
  >
> = [
  'make',
  'modelFamily',
  'bodyStyle',
  'fuelType',
  'drive',
  'transmission',
  'hybridType',
  'secondaryFuelType',
  'battery',
  'electricVehicleBattery',
];

// Additional nested fields that are part of the state object and should be reset
export const TYPE_DEPENDENT_STATE_FIELDS: Array<`state.${keyof CreateVehicleRequestBody['state']}`> =
  ['state.gasRevisionValidUntil', 'state.pressureVesselValidUntil'] as const;
